import format from "date-fns/format";
import { isNil } from "lodash";

export const notEqualsStates = (newStats: object[], prevStats: object[]) => {
    if (isNil(newStats) || isNil(prevStats)) {
        return true;
    }

    if (newStats.length !== prevStats.length) {
        return true;
    }

    for (let i = 0; i < newStats.length; i++) {
        const newStr = JSON.stringify(newStats[i]);
        const prevStr = JSON.stringify(prevStats[i]);

        if (newStr !== prevStr) {
            return true;
        }
    }

    return false;
};

export type AnyType = string | number | bigint | null | undefined;

export const formatDate = (_date?: AnyType, nullResult: string | null = "NO REG") => {
    if (!_date) return nullResult;
    const millisecondsSinceEpoch = Number(_date) * 24 * 60 * 60 * 1000;
    const date = new Date(millisecondsSinceEpoch);
    return format(new Date(Number(date)), "dd/MM/yyyy");
};

export const getEndDate = (_date: AnyType, months: AnyType) => {
    if (isNil(_date)) {
        return null;
    }

    const millisecondsSinceEpoch = Number(_date) * 24 * 60 * 60 * 1000;
    const date = new Date(millisecondsSinceEpoch);
    date.setMonth(date.getMonth() + Number(months));

    return format(new Date(Number(date)), "dd/MM/yyyy");
};
